import { lazy } from 'react'
import { observer } from 'mobx-react-lite'

const Inner = lazy(() => import('./Inner'))

/**
 * Hosts the IAM dialogs that may be shown from anywhere in the app.
 */
export const IamDialogsHost = observer(function IamDialogsHost() {
  return <Inner />
})
